import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Image } from "../models";
import { WriteResource } from "../types";
import { RootState } from "../store";
import { deleteImage } from "../api";

export interface ArchiveImageForm {
  readonly image: Image;
  readonly reasonForChange: string | null;
}

export type ArchiveImageDialogState =
  | {
      readonly isOpen: true;
      readonly image: WriteResource<ArchiveImageForm, Image>;
    }
  | {
      readonly isOpen: false;
    };

// thunks
export const imageArchive = createAsyncThunk(
  "archiveImageDialog/imageArchive",
  async (_: void, thunkApi) => {
    const { getState } = thunkApi;
    const rootState = getState() as RootState;
    const state = rootState.archiveImageDialog;

    if (state.isOpen) {
      await deleteImage({
        value: state.image.data.image.id,
        reasonForChange: state.image.data.reasonForChange || undefined
      });
    }
  }
);

export const archiveImageDialogSlice = createSlice({
  name: "archiveImageDialog",
  initialState: { isOpen: false } as ArchiveImageDialogState,
  reducers: {
    openArchiveImageDialog: (state, action) => {
      return {
        isOpen: true,
        image: {
          data: {
            image: action.payload,
            reasonForChange: null
          }
        }
      };
    },
    closeArchiveImageDialog: state => {
      state.isOpen = false;
    },
    setArchiveImageForm: (state, action) => {
      if (state.isOpen) {
        state.image = {
          data: action.payload
        };
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(imageArchive.fulfilled, () => {
      return { isOpen: false } as ArchiveImageDialogState;
    });
    builder.addCase(imageArchive.rejected, (state, action) => {
      if (state.isOpen) {
        state.image = {
          data: state.image.data,
          errorMessage: action.error.message
        };
      }
    });
  }
});

export const {
  openArchiveImageDialog,
  closeArchiveImageDialog,
  setArchiveImageForm
} = archiveImageDialogSlice.actions;
export default archiveImageDialogSlice.reducer;
